/* this might become a server component in the future. It depends on Linkbox */
'use client';

import { Html } from '../Html/Html.client';
import { LinkByButton } from '../LinkByButton/LinkByButton';
import { LinkByText } from '../LinkByText/LinkByText';
import { SoftHyphenInjector } from '../SoftHyphenInjector';
import { mapButtonTypeToLayout } from '../../utils/mapButtonTypeToLayout';
import type { LinkBoxItemContentComponentType } from './types';
import { classes } from '../../utils/classes';

/**
 * The LinkBoxItemContent component displays content of the LinkBox
 */
export const LinkBoxItemContent = ({
  data: {
    // content
    field_subline_90: subline,
    field_headline_120: headline,
    field_html_editor: htmlContent,
    // call to action
    field_button_text: buttonText,
    // cta button
    behavior_paragraph_cta_icon: buttonIcon,
    behavior_paragraph_cta_size: buttonSize = 'small',
    behavior_paragraph_cta_type: buttonType = 'button-default',
    // Options:
    // 	• standard (without background color)
    // 	• boxed (with bg color)
    behavior_paragraph_variant: layoutVariant,
    // Glycerin Tracking
    behavior_paragraph_campaign_type: glycerinCampaignType,
    behavior_paragraph_campaignid: glycerinCampaginId,
    behavior_paragraph_category: glycerinCategory,
    behavior_paragraph_detail: glycerinDetail,
    behavior_paragraph_name: glycerinName,
  },
  link,
  linkTarget,
  linkRel,
  isLandscape,
}: LinkBoxItemContentComponentType) => (
  <div
    className={classes(
      'h-full px-0 py-1.5',
      isLandscape ? 'w-1/2' : 'w-full',
      layoutVariant === 'boxed' && 'px-1.5',
    )}
  >
    {subline && (
      <p>
        <SoftHyphenInjector text={subline} />
      </p>
    )}
    {headline && (
      <p className="text-size-headline-xl mb-1 font-semibold">
        <SoftHyphenInjector text={headline} />
      </p>
    )}
    {htmlContent && (
      <div className="mb-1">
        <Html data={{ type: 'html', field_html_editor: htmlContent }} />
      </div>
    )}
    {link !== '' && buttonText && buttonType && !['textlink', 'caption'].includes(buttonType) && (
      <LinkByButton
        data={{
          type: 'link_by_button',
          field_link: link,
          field_link_target: linkTarget,
          behavior_paragraph_link_rel: linkRel === '_none' ? undefined : linkRel,
          field_text: buttonText,
          field_layout: mapButtonTypeToLayout(buttonType),
          behavior_paragraph_size: buttonSize,
          behavior_paragraph_campaign_type: glycerinCampaignType,
          behavior_paragraph_campaignid: glycerinCampaginId,
          behavior_paragraph_category: glycerinCategory,
          behavior_paragraph_detail: glycerinDetail,
          behavior_paragraph_name: glycerinName,
        }}
        icon={buttonIcon ? 'ArrowRight' : undefined}
      />
    )}
    {link !== '' && buttonText && buttonType === 'textlink' && (
      <LinkByText
        noUnderline
        data={{
          type: 'link_by_text',
          field_link: link,
          field_link_target: linkTarget,
          behavior_paragraph_link_rel: linkRel === '_none' ? undefined : linkRel,
          field_text: buttonText,
          field_icon: buttonIcon ? 'ArrowRight' : undefined,
          behavior_paragraph_campaign_type: glycerinCampaignType,
          behavior_paragraph_campaignid: glycerinCampaginId,
          behavior_paragraph_category: glycerinCategory,
          behavior_paragraph_detail: glycerinDetail,
          behavior_paragraph_name: glycerinName,
        }}
      />
    )}
  </div>
);
